import * as Yup from "yup";

export const validation = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  stage_template_id: Yup.string().required("Evaluation type is required"),
});

export const model = {
  name: "",
  instruction: "",
  description: "",
  options: [],
  topics: [],
  industrys: [],
  companies: [],
  members: [],
  countries: [],
  visibility: "all",
  stage_template_id: "",
  select_all_members: false,
  select_all_companies: false,
  selected_member_ids: [],
  selected_company_ids: [],
};
